import React from "react";
import SliderLeftArrow from "./../../../../media/slider-left-arrow.svg";
const LeftArrow = ({ prevSlide, coolButtons }) => {
  return (
    <div
      className={coolButtons ? "left-arrow cool-buttons" : "left-arrow"}
      onClick={prevSlide}
    >
      <img alt="" src={SliderLeftArrow} />
    </div>
  );
};
export default LeftArrow;
